import { gql } from '@apollo/client';

export const createCheckoutHealthOffer = gql`
  mutation createCheckoutHealthOffer(
    $soId: String
    $birthDate: String!
    $email: String!
    $phoneNumber: String!
    $source: String
    $productTypeCode: String!
    $productCode: String!
    $coverages: [String!]
  ) {
    createCheckoutHealthOffer(
      soId: $soId
      birthDate: $birthDate
      email: $email
      phoneNumber: $phoneNumber
      source: $source
      productTypeCode: $productTypeCode
      productCode: $productCode
      coverages: $coverages
    )
  }
`;